<template>
  <div class="sc-tab">
    <div v-if="comments.length" class="sc-list">
      <div v-for="c in comments" :key="c.id" class="sc-item" :class="{ resolved: c.resolved }">
        <span class="sc-avatar" :style="{ background: avatarColor(c.author) }">{{ initials(c.author) }}</span>
        <div class="sc-body">
          <div class="sc-meta">
            <span class="sc-author">{{ c.author }}</span>
            <span class="sc-time">{{ relativeTime(c.createdAt) }}</span>
          </div>
          <div class="sc-text">{{ c.text }}</div>
          <button class="sc-resolve" :class="{ done: c.resolved }" @click="toggleResolved(c)">
            <span class="sc-resolve-dot"></span>
            {{ c.resolved ? 'Resolved' : 'Mark resolved' }}
          </button>
        </div>
      </div>
    </div>
    <div v-else class="sc-empty">No comments yet on this stage.</div>

    <div class="sc-compose">
      <textarea
        v-model="draft"
        class="sc-input"
        rows="3"
        placeholder="Add a comment about this stage..."
        @keydown.ctrl.enter="post"
        @keydown.meta.enter="post"
      ></textarea>
      <div class="sc-compose-actions">
        <span class="sc-hint">Ctrl/Cmd + Enter to post</span>
        <button class="sc-post" :disabled="!draft.trim()" @click="post">Post</button>
      </div>
    </div>
  </div>
</template>

<script>
import { listComments, addComment, setCommentResolved } from './journeyComments'
import { initials, avatarColor, relativeTime } from './commentDisplay'

export default {
  name: 'stage-comments-tab',
  props: {
    journeyKey: { type: String, default: '' },
    stageName: { type: String, default: '' }
  },
  data () {
    return {
      draft: '',
      comments: []
    }
  },
  watch: {
    journeyKey () { this.refresh() },
    stageName () { this.refresh() }
  },
  created () {
    this.refresh()
  },
  methods: {
    refresh () {
      this.comments = listComments(this.journeyKey, this.stageName)
    },
    post () {
      if (!this.draft.trim()) return
      addComment(this.journeyKey, this.stageName, this.draft)
      this.draft = ''
      this.refresh()
    },
    toggleResolved (c) {
      setCommentResolved(this.journeyKey, c.id, !c.resolved)
      this.refresh()
    },
    initials,
    avatarColor,
    relativeTime
  }
}
</script>

<style scoped>
.sc-list{display:flex;flex-direction:column;gap:12px;margin-bottom:16px}
.sc-empty{font-size:12px;color:var(--text-faint);padding:8px 0 16px}

.sc-item{display:flex;gap:9px}
.sc-avatar{
  width:24px;height:24px;border-radius:50%;color:#fff;flex-shrink:0;
  display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;
}
.sc-body{flex:1;min-width:0}
.sc-meta{display:flex;align-items:baseline;gap:7px}
.sc-author{font-size:12px;font-weight:600;color:var(--text)}
.sc-time{font-size:10.5px;color:var(--text-faint)}
.sc-text{font-size:12px;color:var(--text);line-height:1.5;margin-top:3px;word-break:break-word}
.sc-item.resolved .sc-text{color:var(--text-muted)}

.sc-resolve{
  display:inline-flex;align-items:center;gap:5px;margin-top:6px;background:none;border:none;padding:0;
  font-size:11px;font-weight:600;color:var(--text-muted);cursor:pointer;font-family:inherit;
}
.sc-resolve:hover{color:var(--accent-strong)}
.sc-resolve-dot{width:10px;height:10px;border-radius:50%;border:1.5px solid currentColor;flex-shrink:0}
.sc-resolve.done{color:var(--accent-strong)}
.sc-resolve.done .sc-resolve-dot{background:var(--accent-strong);border-color:var(--accent-strong)}

.sc-compose{margin-top:6px;border-top:1px solid var(--card-border);padding-top:12px}
.sc-input{
  width:100%;resize:vertical;font-family:inherit;font-size:12px;line-height:1.5;color:var(--text);
  padding:9px 10px;border:1px solid var(--card-border);border-radius:8px;background:var(--card);
}
.sc-input::placeholder{color:var(--text-faint)}
.sc-input:focus{outline:none;border-color:var(--accent)}
.sc-compose-actions{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:8px}
.sc-hint{font-size:10.5px;color:var(--text-faint)}
.sc-post{
  padding:6px 14px;border-radius:6px;border:none;background:var(--accent-strong);color:#fff;
  font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;
}
.sc-post:hover:not(:disabled){opacity:0.9}
.sc-post:disabled{opacity:0.4;cursor:default}
</style>



// WEBPACK FOOTER //
// StageCommentsTab.vue?d0040b7e